/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber9 = createReactComponent("outline", "number-9", "IconNumber9", [["path", { "d": "M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0", "key": "svg-0" }], ["path", { "d": "M8 16a4 4 0 1 0 8 0v-8", "key": "svg-1" }]]);

export { IconNumber9 as default };
//# sourceMappingURL=IconNumber9.mjs.map
